<template>
    <fieldset :disabled="disabled">
        <div class="ibox-content" data-cy="register-user-form-box">
            <h4 class="m-b">{{ boxTitle }}</h4>

            <div class="form-group row m-b-sm m-t">
                <div
                    class="col-md-12 col-sm-12"
                    :class="hasError('name') ? 'has-error' : ''"
                    data-cy="register-user-form-name-div"
                >
                    <input-wrapper
                        :label="
                                __(
                                    'company_name_or_first_name_and_second_name'
                                ) + '*'
                            "
                        type="text"
                        classNames="form-control"
                        name="name[]"
                        data-cy="register-user-form-name-input"
                        v-model="formData.name"
                        @input="updateForm"
                        :errors="getErrors('name')"
                    />
                </div>
                <div
                    class="col-md-12 m-b-sm"
                    data-cy="register-user-form-input-adress1-div"
                    :class="hasError('address1') ? 'has-error' : ''"
                >
                    <input-wrapper
                        :label="__('address') + '*'"
                        type="text"
                        classNames="form-control"
                        name="address1[]"
                        data-cy="register-user-form-input-adress1"
                        v-model="formData.address1"
                        @input="updateForm"
                        :errors="getErrors('address1')"
                    />
                </div>
                <div
                    class="col-md-12 m-b-sm"
                    data-cy="register-user-form-input-adress2-div"
                    :class="hasError('address2') ? 'has-error' : ''"
                >
                    <input-wrapper
                        type="text"
                        classNames="form-control"
                        data-cy="register-user-form-input-adress2"
                        name="address2[]"
                        v-model="formData.address2"
                        @input="updateForm"
                        :errors="getErrors('address2')"
                    />
                </div>
                <div
                    class="col-5 m-b-sm"
                    data-cy="register-user-form-input-zip-div"
                    :class="hasError('zip') ? 'has-error' : ''"
                >
                    <input-wrapper
                        :label="__('zip') + '*'"
                        type="text"
                        classNames="form-control"
                        name="zip[]"
                        data-cy="register-user-form-input-zpi"
                        v-model="formData.zip"
                        @input="updateForm"
                        :errors="getErrors('zip')"
                    />
                </div>
                <div
                    class="col-7 m-b-sm"
                    data-cy="register-user-form-input-city-div"
                    :class="hasError('city') ? 'has-error' : ''"
                >
                    <input-wrapper
                        :label="__('city') + '*'"
                        type="text"
                        classNames="form-control"
                        name="city[]"
                        data-cy="register-user-form-input-city"
                        v-model="formData.city"
                        @input="updateForm"
                        :errors="getErrors('city')"
                    />
                </div>
                <div
                    class="col-5"
                    data-cy="register-user-selected-country-div"
                    :class="hasError('countrySelected') ? 'has-error' : ''"
                >
                    <label data-cy="register-user-label-country">{{ __("country") }}*</label>
                    <select-2
                        :options="countriesSelect2"
                        classNames="form-control"
                        :settings="{ width: '100%' }"
                        v-model="formData.countrySelected"
                        name="countrySelected[]"
                        data-cy="register-user-selector-country"
                        @change="countryChanged"
                        @input="updateForm"
                        :disabled="
                                disabled || mode == 'application-settings'
                            "
                    />
                    <span
                        class="help-block text-danger"
                        data-cy="register-user-input-error"
                        v-if="hasError('countrySelected')"
                    >
                            {{ getError("countrySelected") }}
                        </span>
                </div>
                <div
                    class="col-2 text-right"
                    data-cy="register-user-form-checkbox-department-div"
                    style=""
                >
                    <label style="margin-left: -11px"> {{ __("client_department") }}</label>
                    <input
                        type="checkbox"
                        v-model="
                                            formData.departmentCountryChecked
                                        "
                        :name="
                                            'departmentCountryChecked[' +
                                                index +
                                                ']'
                                        "
                        data-cy="register-user-form-checkbox-department"
                        :true-value="true"
                        :false-value="false"
                        @change="departmentCountryChange"
                        @input="updateForm"
                        :disabled="
                                            mode == 'application-settings'
                                        "
                    />

                </div>
                <div
                    class="col-5  m-b-sm "
                    data-cy="register-user-form-selector-departmentCountry-div"
                    :class="
                                    hasError('departmentCountrySelected')
                                        ? 'has-error'
                                        : ''
                                "
                >
                    <label>{{ __("department_country") }}*</label>
                    <select-2
                        :options="countriesSelect2"
                        :settings="{ width: '100%' }"
                        data-cy="register-user-form-selector-departmentCountry"
                        v-model="formData.departmentCountrySelected"
                        name="departmentCountrySelected[]"
                        :readonly="
                                        !formData.departmentCountryChecked
                                    "
                        :disabled="
                                        disabled ||
                                            mode == 'application-settings'
                                    "
                        @change="departmentCountryChanged"
                        @input="updateForm"
                    />
                    <span
                        class="help-block text-danger"
                        v-if="hasError('departmentCountrySelected')"
                    >
                                    {{ getError("departmentCountrySelected") }}
                                </span>
                </div>
                <div
                    class="col-5"
                    data-cy="register-user-select-idType-div"
                    :class="
                                    hasError('idNumberType') ? 'has-error' : ''
                                "
                >
                    <label
                    >{{
                            __("identification_number_typ")
                        }}*</label
                    >
                    <select-2
                        :options="filteredidNumbersSelect2"
                        :settings="{ width: '100%' }"
                        v-model="formData.idNumberType"
                        name="idNumberType[]"
                        classNames="form-control"
                        :disabled="disabled ||mode == 'application-settings'"
                        @change="idNumberChanged"
                        @input="updateForm"
                    />
                    <span
                        class="help-block text-danger"
                        v-if="hasError('idNumberType')"
                    >
                                    {{ getError("idNumberType") }}
                                </span>
                </div>
                <div class="col-6" >
                    <div
                        :class="
                                        hasError('idNumber') ? 'has-error' : ''
                                    "
                    >
                        <input-wrapper
                            :label="
                                            __('identification_number') + '*'
                                        "
                            type="text"
                            classNames="form-control"
                            name="idNumber[]"
                            data-cy="register-user-form-idnumber-one-input"
                            v-model="formData.idNumber"
                            @input="updateForm"
                            :errors="getErrors('idNumber')"
                            :readonly="!isSelectedIdNumber || !!idVies"
                            :disabled="
                                            mode == 'application-settings'
                                        "
                        >
                            <template
                                v-slot:append
                                v-if="
                                                formData.departmentCountryChecked === false && isIdNumberNip &&
                                                    !disabled &&
                                                    mode !=
                                                        'application-settings'
                                            "
                            >
                                <button
                                    type="button"
                                    class="btn btn-primary tooltip-more"
                                    data="btn-arrow"
                                    title=""
                                    v-tooltip="
                                                    __('get_data_from_gus')
                                                "
                                    @click="
                                                    getDataFromGUS('idNumber')
                                                "
                                >
                                    <i class="fas fa-search" data-cy="register-user-button-info1" ></i>
                                </button>
                            </template>
                        </input-wrapper>
                    </div>
                </div>
                <div
                    class="col-1 text-center"
                    v-if="
                                    viesButton && mode != 'application-settings'
                                "
                >
                    <label style="margin-left: -15px;">VIES</label><br/>
                    <input
                        type="checkbox"
                        style="margin-top:8px;margin-left: -10px"
                        name="idNumberVies"
                        data-cy="register-user-form-checkbox-vies-one-div"
                        v-model="idVies"
                        @click="idViesClick"
                        :disabled="isViesDisabled(0)"
                    />
                </div>
                <div
                    class="col-5"
                    data-cy="register-user-select-secendary-id"
                    :class="
                                    hasError('idNumberSecondaryType')
                                        ? 'has-error'
                                        : ''
                                "
                >
                    <label class="white-space-no-wrap"
                    >{{
                            __(
                                "secondary_id_number_id"
                            )
                        }}*</label
                    >
                    <select-2
                        :settings="{ width: '100%' }"
                        :options="filteredidNumbersSelect2"
                        v-model="formData.idNumberSecondaryType"
                        name="idNumberSecondaryType[]"
                        :disabled="disabled ||mode == 'application-settings'"
                        @change="idNumberSecondaryChanged"
                        @input="updateForm"
                    />
                    <span
                        class="help-block text-danger"
                        v-if="hasError('idNumberSecondaryType')"
                    >
                                    {{ getError("idNumberSecondaryType") }}
                                </span>
                </div>
                <div
                    class="col-6"
                    data-cy="register-user-form-selector-id2-div"
                    :class="
                                    hasError('idNumberSecondary')
                                        ? 'has-error'
                                        : ''
                                "
                >
                    <input-wrapper
                        :label="__('identification_number') + '*'"
                        type="text"
                        classNames="form-control"
                        name="idNumberSecondary[]"
                        data-cy="register-user-form-idnumber-two-input"
                        v-model="formData.idNumberSecondary"
                        @input="updateForm"
                        :errors="getErrors('idNumberSecondary')"
                        :readonly="!isSelectedIdNumberSecondary || !!idSecondaryVies"
                        :disabled="mode == 'application-settings'"
                    >
                        <template
                            v-slot:append
                            v-if="
                                            formData.departmentCountryChecked === false && isSecondaryIdNumberNip &&
                                                !disabled &&
                                                mode != 'application-settings'
                                        "
                        >
                            <button
                                type="button"
                                class="btn btn-primary tooltip-more"
                                data-cy="register-user-form-btn-tooltip-more"
                                title=""
                                v-tooltip="
                                                    __('get_data_from_gus')
                                                "
                                @click="
                                                getDataFromGUS(
                                                    'idNumberSecondary'
                                                )
                                            "
                            >
                                <i class="fas fa-search" data-cy="register-user-button-info2"></i>
                            </button>
                        </template>
                    </input-wrapper>
                </div>
                <div
                    class="col-1 text-center"
                    v-if="
                                    viesButton && mode != 'application-settings'
                                "
                >
                    <label style="margin-left: -15px;">VIES</label><br/>
                    <input
                        type="checkbox"
                        style="margin-top:8px;margin-left: -10px;"
                        name="idNumberSecondaryVies"
                        data-cy="register-user-form-checkbox-vies-two-div"
                        v-model="idSecondaryVies"
                        @click="idSecondaryViesClick"
                        :disabled="isViesDisabled(1)"
                    />
                </div>
            </div>
            <span v-if="index == 0 && showOwnerWarning" class="text-danger text-bold">{{__("register_form_invoice_warning") }}</span>
            <span v-if="index == 1 && showOtherCompanyWarning" class="text-danger text-bold">{{__("register_form_invoice_warning") }}</span>
            <div
                class="form-group row m-b-sm mt-1"
                data-cy="register-user-form-checkbox-copyClientData-div"
                v-if="copyClientDataButton && mode != 'application-settings'"
            >
                <div class="col-12">
                    <label
                    ><input
                        type="checkbox"
                        v-model="copyClientDataCheckbox"
                        @click="copyClientData"
                        @input="updateForm"
                        name="copyClientData"
                        data-cy="register-user-form-checkbox-copyClientData"
                        :value="true"
                    />
                        {{ __("other_data_user_entity") }}</label
                    >
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script>

import {mapGetters, mapActions} from "vuex";
import InputWrapper from "../../form/InputWrapper.vue";
import permissions from './../../../services/Permissions.js';

export default {
    components: {
        InputWrapper
    },
    data() {
        return {
            idVies: false,
            idSecondaryVies: false,
            isCopyClientData: false,
            copyClientDataCheckbox : false,
            formData: {
                name: "",
                countrySelected: 9,
                idNumberType: null,
                idNumber: "",
                idNumberSecondaryType: "",
                idNumberSecondary: "",
                address1: "",
                address2: "",
                zip: "",
                city: "",
                remarks: "",
                departmentCountryChecked: false,
                departmentCountrySelected: null,
                short_name: ""
            }
        };
    },
    props: {
        countryTranslations: {
            type: Object,
            default: () => ({})
        },
        value: {
            type: Object,
            default: null
        },
        boxTitle: {
            type: String,
            default: ""
        },
        viesButton: {
            type: Boolean,
            default: false
        },
        deleteButton: {
            type: Boolean,
            default: false
        },
        copyClientDataButton: {
            type: Boolean,
            default: false
        },
        isEnabledCopyButton: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: -1
        },
        index: {
            type: Number,
            default: -1
        },
        countryProp: {
            default: null
        },
        idNumberTypeProp: {
            default: null
        },
        copyButtonChecked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        logo: {
            type: Boolean,
            default: false
        },
        shortName: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String
        },
        permission_access: {
            default: null
        },
    },
    computed: {
        showOwnerWarning(){
            const idTypeObj = this.filteredidNumbersSelect2.find(
                item => item.id == this.formData.idNumberType
            );

            const secondaryTypeObj = this.filteredidNumbersSelect2.find(
                item => item.id == this.formData.idNumberSecondaryType
            );
            return  idTypeObj?.used_in_invoice_overlay == 0 &&
                secondaryTypeObj?.used_in_invoice_overlay == 0 && this.index == 0 && !this.copyClientDataCheckbox ;
        },
        showOtherCompanyWarning(){
            const idTypeObj = this.filteredidNumbersSelect2.find(
                item => item.id == this.formData.idNumberType
            );

            const secondaryTypeObj = this.filteredidNumbersSelect2.find(
                item => item.id == this.formData.idNumberSecondaryType
            );
            return idTypeObj?.used_in_invoice_overlay == 0 &&
                secondaryTypeObj?.used_in_invoice_overlay == 0 && this.index == 1;
        },
        showLogo() {
            return permissions.getPermission(this.permission_access, 'perm_view_application.settings_crud_logo')
        },
        filteredidNumbersSelect2() {
            let filtered = this.idNumbersSelect2.filter(element => {
                let countryId = 0;
                if (this.formData.departmentCountryChecked) {
                    countryId = this.formData.departmentCountrySelected;
                } else {
                    countryId = this.formData.countrySelected;
                }
                if(this.index == 0){
                    return (
                        (element.country_id == countryId && element.related_type != 'natural_person') ||
                        element.text == "other" ||
                        element.text == "none"
                    );
                }
                return (
                    element.country_id == countryId ||
                    element.text == "other" ||
                    element.text == "none"
                );
            });

            let translated = [];
            filtered.forEach(element => {
                let tempElement = {...element};
                tempElement.text = this.__(element.text);
                translated.push(tempElement);
            });

            return translated;
        },
        isSelectedIdNumber() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberType
            );
            return (
                this.formData.idNumberType != null &&
                inputName != undefined &&
                inputName.text != "none"
            );
        },
        isSelectedIdNumberSecondary() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberSecondaryType
            );
            return (
                this.formData.idNumberSecondaryType != null &&
                inputName != undefined &&
                inputName.text != "none"
            );
        },
        isIdNumberNip() {
            let number = this.filteredidNumbersSelect2.find(obj => {
                return obj.id == this.formData.idNumberType;
            });

            return number != undefined ? number.text == "NIP" : false;
        },
        isSecondaryIdNumberNip() {
            let number = this.filteredidNumbersSelect2.find(obj => {
                return obj.id == this.formData.idNumberSecondaryType;
            });

            return number != undefined ? number.text == "NIP" : false;
        },

        ...mapGetters({
            countriesSelect2: "getCountriesSelect2",
            idNumbersSelect2: "getIdNumbersTypes",
            selectedDepartment: "getSelectedSaDepartment",
            errors: "getErrors",
            old: "getOld",
            values: "getValues"
        })
    },
    methods: {
        isViesDisabled(index) {
            let countryId = -1;
            if (this.formData.departmentCountryChecked) {
                countryId = this.formData.departmentCountrySelected;
            } else {
                countryId = this.formData.countrySelected;
            }
            let country = this.countriesSelect2.find(
                element => element.id == countryId
            );

            let inputName = this.idNumbersSelect2.find(
                element => element.id == (index === 0 ? this.formData.idNumberType : this.formData.idNumberSecondaryType)
            )

            if(country == undefined){
                this.resetViesCheckboxes(index);
                return true;
            }

            if(inputName !== undefined && (inputName.text === "none" || inputName.can_be_vies == 0)){
                this.resetViesCheckboxes(index);
                return true;
            }
            return false;
        },
        resetViesCheckboxes(index) {
            if(index == 0){
                this.idVies = false;
            }
           else{
                this.idSecondaryVies = false;
            }
        },
        countryChanged() {
            if (this.formData.departmentCountryChecked == false) {
                this.$emit("changeCountry", this.formData.countrySelected);
                this.setDefaultIdNumbersSelects();
                this.$emit("chamgeIdType", this.formData.idNumberType);
            }
        },
        departmentCountryChanged() {
            if (
                this.formData.departmentCountryChecked == true ||
                this.formData.departmentCountryChecked == "on"
            ) {
                this.$emit(
                    "changeCountry",
                    this.formData.departmentCountrySelected
                );
                this.setDefaultIdNumbersSelects();
                this.$emit("chamgeIdType", this.formData.idNumberType);
            }
        },
        setDefaultIdNumbersSelects() {
            let isDefaultSelected = false;

            this.filteredidNumbersSelect2.forEach(element => {
                if (
                    element.related_type == "other_entities" &&
                    !isDefaultSelected
                ) {
                    this.formData.idNumberType = element.id;
                    isDefaultSelected = true;
                }
            });

            if (!isDefaultSelected) {

                this.formData.idNumberType = this.filteredidNumbersSelect2[0].id;
            }

            this.setSecondIdTypeNone();
        },
        departmentCountryChange() {
            this.$set(this.formData, "departmentCountrySelected", -1);
            this.setDefaultIdNumbersSelects();
            this.$emit("changeCountry", this.formData.countrySelected);
            this.$emit("chamgeIdType", this.formData.idNumberType);
        },
        idNumberSecondaryChanged() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberSecondaryType
            );

            if (inputName != undefined && inputName.text == "none") {
                this.formData.idNumberSecondary = "";
            }
        },
        idNumberChanged() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberType
            );

            this.$emit("chamgeIdType", this.formData.idNumberType);
            if (inputName != undefined && inputName.text == "none") {
                this.formData.idNumber = "";
            }
        },
        updateFormCountry() {
            this.formData.countrySelected =
                this.selectedDepartment.department_country != null
                    ? this.selectedDepartment.department_country.id
                    : this.selectedDepartment.country.id;

            if (this.formData.departmentCountryChecked == false) {
                this.setDefaultIdNumbersSelects();
                this.setSecondIdTypeNone();
            }
        },
        deleteForm() {
            $(function () {
                $(".tooltip").remove();
            });
            this.$emit("delete", this.id);
        },
        copyClientData() {
            this.$emit("copy", this.formData);
            this.$emit("copyData", this.formData);
        },
        updateForm() {
            this.$emit("input", this.formData);
        },
        async idViesClick() {
            if (this.idVies == false) {
                this.idSecondaryVies = false;
            }
            if (!this.idVies) {
                let response = await make_vies_simple_check({
                    'type': this.formData.idNumberType,
                    'number': this.formData.idNumber
                })
                if (response.valid) {
                    handle_valid_response_vies_simple_check(response)
                } else {
                    handle_invalid_response_vies_simple_check(response)
                    this.idVies = false;
                }
            }
        },
        async idSecondaryViesClick() {
            if (this.idSecondaryVies == false) {
                this.idVies = false;
            }
            if (!this.idSecondaryVies) {
                let response = await make_vies_simple_check({
                    'type': this.formData.idNumberSecondaryType,
                    'number': this.formData.idNumberSecondary
                })
                if (response.valid) {
                    handle_valid_response_vies_simple_check(response)
                } else {
                    handle_invalid_response_vies_simple_check(response)
                    this.idSecondaryVies = false;
                }
            }
        },
        hasError(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined;
        },
        getErrors(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined
                ? this.errors[`${inputName}.${this.index}`]
                : [];
        },
        getError(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined
                ? this.errors[`${inputName}.${this.index}`][0]
                : [];
        },
        setData(data) {

            if (this.old.length != 0) {
                for (const [key, value] of Object.entries(this.old)) {
                    if (value != null && value[this.index] != undefined) {
                        this.$set(this.formData, key, value[this.index]);
                    }
                }

                if (data.idNumberVies) {
                    this.idVies = true;
                } else if (data.idNumberSecondaryVies) {
                    this.idSecondaryVies = true;
                }
            }
        },
        setSecondIdTypeNone(withIdNumberType) {
            let none = this.idNumbersSelect2.find(
                element => element.text == "none"
            );

            this.formData.idNumberSecondaryType = none.id;
            this.formData.idNumberSecondary = "";
            if(withIdNumberType){
                this.formData.idNumberType = none.id;
                this.formData.idNumber = "";
            }
        },
        getDataFromGUS(inputName) {
            let nip = this.formData[inputName];
            this.getGusInfoNotLogged({nip: nip}).then(response => {
                let data = response.data;

                if (data.success == true) {
                    this.updateClientFormFromGUS(data.data[0]);

                    toastr["info"](
                        this.__("clients_data_have_been_imported")
                    ).css("border", "0px");
                } else {
                    genericSwalGUSError();
                }
            });
        },
        updateClientFormFromGUS(data) {
            this.formData.name = data.name;
            let street = data.street.replace("ul. ", "");
            street = street.concat(" ", data.propertyNumber);

            if (data.apartmentNumber != "") {
                street = street.concat("/", data.apartmentNumber);
            }

            this.formData.address1 = street;
            this.formData.zip = data.zipCode;
            this.formData.city = data.postCity;
        },
        ...mapActions(["getGusInfoNotLogged"])
    },

    mounted() {
        this.setData(this.old);
        if (this.idNumberTypeProp != null) {
            this.formData.idNumberType = this.idNumberTypeProp;
        } else if (this.formData.idNumberType == null) {
            let isDefaultSelected = false;
            const foundIndex = this.filteredidNumbersSelect2.findIndex(element =>
                element.related_type === "other_entities" &&
                element.country_id === this.formData.countrySelected &&
                !isDefaultSelected
            );
            console.log('index',foundIndex)
            if (foundIndex !== -1 && this.index === 0) {
                this.formData.idNumberType = this.filteredidNumbersSelect2[foundIndex].id;
            }
            else{
                if(this.index == 0){
                    this.formData.idNumberType = this.filteredidNumbersSelect2[0].id;
                }
            }
        }
        this.isCopyClientData = this.copyButtonChecked;
        $(".tooltip-more").tooltip();
        if (!this.isCopyClientData && Object.keys(this.old).length === 0) {
            this.setSecondIdTypeNone(this.index===1);
        }
        if (
            this.old.copyClientData != undefined ||
            (Object.keys(this.old).length == 0 &&
                this.values.isDataCopied != undefined &&
                this.values.isDataCopied)
        ) {
            this.isCopyClientData = true;
        }
    },
}
</script>

<style scoped>
@media (max-width: 400px) {
    .row > [class*="col-"] {
        padding-left: 0 px !important;
        padding-right: 5px !important;
    }
}
</style>
